module.exports = __webpack_public_path__ + "img/FischspezialitätenMundt.bc71ae84.svg";